/**
 * Reusable Tailwind spacing/layout class fragments for consistent UI.
 * All values use the existing Tailwind default scale (no new arbitrary px/rem).
 *
 * Scale reference (spacing-* / gap-*):
 * - xs: 2 → 0.5rem
 * - sm: 3 → 0.75rem
 * - md: 4 → 1rem
 * - lg: 5 → 1.25rem
 * - xl: 6 → 1.5rem
 * - 2xl: 8 → 2rem
 *
 * Page shell horizontal/vertical padding: see `PAGE_CONTENT_CLASS` in `components/layout/PageContent.jsx`.
 */

/** Contract send modals: scrollable body (signature / evaluation). */
export const MODAL_BODY_SCROLL_CONTRACT = 'p-4 overflow-y-auto space-y-6 flex-1';

/** Sticky footer: end-aligned actions + top border (send modals). */
export const MODAL_STICKY_FOOTER_END = 'flex justify-end gap-3 p-4 border-t border-border flex-shrink-0';

/** Payment step: full-width paired buttons. */
export const MODAL_FOOTER_PAYMENT_ACTIONS = 'p-4 border-t flex gap-3';

/** Simple dialogs: end-aligned button row (no border). */
export const MODAL_DIALOG_ACTIONS_END = 'flex justify-end gap-3';

/** Payment form main scroll region (tighter horizontal padding than contract modals). */
export const PAYMENT_METHOD_FORM_SCROLL_BODY = 'flex-1 overflow-y-auto p-6 space-y-6';

/** License purchase modal content area (responsive horizontal padding + section stack). */
export const PURCHASE_MODAL_BODY = 'p-4 md:p-6 space-y-6';
